<template>
    <rkm-overlay>
        <rkm-layout-body :title="id ? 'Edição de requisição' : 'Nova requisição'">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
                
                <rkm-button
                    v-if="(additionals && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id) && saveButtonShow"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    {{ saveButtonText }}
                </rkm-button>
            </template>
        
            <rkm-layout-content>
                <Form
                    :id="id"
                    @loaded="habdleLoaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/imunizacao/requisicao/Form'

// Enums.
import requisicaoStatus from '@/enums/imunizacao/requisicaoStatus'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    computed: {
        saveButtonShow() {
            let show = false

            if (this.model) {
                if (this.model.statusId === null) {
                    show = true
                }
                else if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                    if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                        show = false
                    } else {
                        show = true
                    }
                }
                else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                    if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                        show = true
                    } else {
                        show = false
                    }
                }
            }

            return show
        },
        saveButtonText() {
            if(this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                return 'Finalizar'
            }
            return 'Salvar'
        }
    },
    data: () => ({
        additionals: null,
        enums: { requisicaoStatus },
        model: null,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
        ]),
        habdleLoaded(object) {
            this.additionals = object.additionals
            this.model = object.model

            if (this.model && this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                if (this.model.salaVacinacaoIdPara === this.additionals.salaVacinacaoLogada.id) {
                    this.setShowExitFormConfirmation()
                }
            }
            else if (this.model && this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    this.setShowExitFormConfirmation()
                }
            }
        },
        handleExit() {
            this.$router.push({ name: 'imunizacao-requisicao-index' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>